<template>
  <router-view />
</template>

<script>
export default {
  name: 'ProviderWrapper',
  data: () => ({
    page: {
      title: 'Proveedor',
      icon: 'fas fa-user-cog',
      routes: ['Proveedor'],
    },
  }),
  provide() {
    return {
      page: this.page,
    };
  },
};
</script>
